import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/chatbot_1';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
